<template>
  <div class="mobile-money has-text-left">

    <!-- breadcrum -->
    <div class="d-flex align-items-center mb-4">
      <router-link to="/dashboard" class="text-hard-bold text-dark" active-class="current">
        <p class="mb-0 font-weight-bold">Dashboard</p>
      </router-link>
      <i class="fas fa-chevron-right mx-3"></i>
      <p class="mb-0">Top Up Wallet</p>
    </div>

    <!-- Content -->
    <div class="row">
      <div class="col-12 col-md-7">
        <div class="rounded background-light-gray border border-dark-gray p-3">
          <form @submit.prevent="submit">
            <p class="font-weight-bold">Select Wallet You Want To Top Up</p>
            <div class="mb-3 pl-0 col-12 col-md-6">
              <p v-if="!options.length">Now loading currencies <b-spinner small></b-spinner></p>
              <b-form-select
                v-model="selected"
                :options="options"
                value-field="iso2"
                text-field="iso2"
              ></b-form-select>
            </div>
            
            <p class="font-weight-bold">Enter Amount You Want To Top Up</p>
            <div class="row mb-5">
              <div class="col-12 col-md-6">
                <currency-input
                  v-model="transaction_amount"
                  locale="en"
                  :auto-decimal-mode="false"
                  :allow-negative="true"
                  class="form-control"
                  placeholder="Top Up Amount"
                  :currency="{}"
                />
              </div>
            </div>

            <button v-if="loading" disabled="" variant="success" class="px-5">Please wait <b-spinner small></b-spinner></button>
            <b-button v-if="!loading" variant="success" type="submit" class="px-5" :disabled="!options.length">Confirm Top Up</b-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jetPayNowApi } from '../api/jetpaynow_api';
import store from '../store';
import TransactionAPI from '../api/transactions_api';

export default {
  data() {
    return {
      selected: 'GHS',
      transaction_amount: null,
      loading: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      TransactionAPI.methods.getCurrencies();
    },
    submit() {
      if (this.transaction_amount > 0) {
        this.loading = true;

        const payload = {
          currency: this.selected,
          transaction_amount: this.transaction_amount
        };

        jetPayNowApi
          .post(`/payments/wallet/top-up/self`, payload)
          .then(verResponse => {
              console.log('wallet topup', verResponse);
              if (verResponse.status === 200) {
                const internal_checkout_url = verResponse.data.internal_checkout_url;
                window.location = internal_checkout_url;
              } else {
                this.loading = false;

                // error, popup error message
              }
          })
          .catch(error => {
              console.log('error', error);
          });
      }
    },
  },
  computed: {
    options: {
      get: function () {
        return store.state.currencies;
      },
      set: function (newValue) {
        store.state.currencies = newValue;
      }
    },
  }
};
</script>
<style scoped>
.section .title-divider {
  margin: auto;
  width: 100px;
  height: 5px;
  background: #00a27f;
}
.light-subtitle {
  font-size: 1.5rem;
  padding: 2% 10% 2% 10%;
  margin-bottom: 0 !important;
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.text-big {
  font-size: 3em;
}
.text-blue {
  color: #0085ba;
}
.background-light-gray {
  background: #f2f2f2;
}
.border-dark-gray {
  border-color: #d9d9d9 !important;
}
.red {
  color: red;
}
.green { 
  color: green;
}
.b-skeleton-wrapper {
  width: 90%;
}
.reflect-rotate {
  transform: rotate(275deg) scaleX(-1);
}
@media (min-width: 768px) {
  .d-md-inline-table {
    display: inline-table !important;
  }
}
@media (max-width: 768px) {
  .rounded-pill {
    border-radius: 5px !important;
  }
}
</style>
